import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach JWT from localStorage if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pf_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const BUSINESS = {
  name: "The Phoenix Fix",
  phone: "(404) 369-0087",
  phoneHref: "tel:+14043690087",
  email: "office@ThePhoenixFix.com",
  hours: "24/7 Service",
  area: "Fulton • DeKalb • Cobb • Gwinnett • Forsyth Counties",
};
